export const faqEnum = {
    value:'value',
    name:'name',
    isEnable:'isEnable',
}
